import { iseeInstance } from '../axiosService'

class RemoteVUService {
  async fetchUsers (portalName, portalOnly = false) {
    return iseeInstance.get(`/users/portal/${portalName}`, {
      params: {
        portalOnly
      }
    })
  }

  async addUser (
    email,
    userName,
    portalName,
    portalRole,
    isScreenVU = false,
    isGlassvuUser = false,
    isScreenvuUser = false,
    isCamvuUser = false,
    isUserOnboardingRequired = false,
    licenceId
  ) {
    return iseeInstance.post('/users/', {
      email,
      name: userName,
      role: portalRole,
      portal: portalName,
      isScreenVU,
      isGlassvuUser,
      isScreenvuUser,
      isCamvuUser,
      isUserOnboardingRequired,
      licenceId
    })
  }

  async editUser (selectedUserId, name, role, users, portalName, licenceId) {
    return iseeInstance.put(`/users/${selectedUserId}`, {
      name,
      role,
      users,
      portal: portalName,
      licenceId
    })
  }

  async removeUser (email, portalName) {
    return iseeInstance.delete('/users/', {
      data: { email, portal: portalName }
    })
  }

  async getUser (selectedUserId) {
    return iseeInstance.get(`/users/${selectedUserId}`)
  }
}

export default new RemoteVUService()
